module.exports = __webpack_public_path__ + "static/img/portrait.379b17f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/portrait.png
// module id = 1304
// module chunks = 7